import React from 'react';
import { cn } from '../../lib/utils';
interface SectionProps {
  children: React.ReactNode;
  background?: 'white' | 'gray' | 'primary' | 'accent';
  className?: string;
}
export function Section({
  children,
  background = 'white',
  className
}: SectionProps) {
  const backgrounds = {
    white: 'bg-white',
    gray: 'bg-gray-50',
    primary: 'bg-primary-900',
    accent: 'bg-accent-50'
  };
  return <section className={cn(backgrounds[background], 'py-10 md:py-14', className)} data-id="element-120">
      <div className="container mx-auto px-4 md:px-6" data-id="element-121">{children}</div>
    </section>;
}